import apiFetch from '@wordpress/api-fetch';

// Helper functions untuk warna (sama seperti di edit.js)
const normalizeHex = (hex = '') => {
    const val = hex.trim();
    if (/^#([0-9a-f]{3})$/i.test(val)) {
        return '#' + val[1] + val[1] + val[2] + val[2] + val[3] + val[3];
    }
    if (/^#([0-9a-f]{6})$/i.test(val)) {
        return val.toLowerCase();
    }
    return '#2271b1';
};

const darkenHex = (hex, amount = 0.12) => {
    const normalized = normalizeHex(hex).replace('#', '');
    const num = parseInt(normalized, 16);
    const r = Math.max(0, Math.floor((num >> 16) * (1 - amount)));
    const g = Math.max(0, Math.floor(((num >> 8) & 0xff) * (1 - amount)));
    const b = Math.max(0, Math.floor((num & 0xff) * (1 - amount)));
    const toHex = (v) => v.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const hexToRgba = (hex, alpha = 1) => {
    const normalized = normalizeHex(hex).replace('#', '');
    const num = parseInt(normalized, 16);
    const r = num >> 16;
    const g = (num >> 8) & 0xff;
    const b = num & 0xff;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.wp-block-create-block-rentalize-client');

    // block for filter asset by start date and end date
    // start date and end date format YYYY-MM-DD HH:MM (24 hours)

    const filterController = () => {
        let filterContainer = document.createElement('div');
        filterContainer.className = 'rentalize-filter-card';
        filterContainer.innerHTML = `
        <div class="rentalize-filter-cta">
            <h3>Mau cari barang untuk disewa kapan?</h3>
            <p>Pilih tanggal mulai dan selesai untuk melihat ketersediaan aset.</p>
        </div>
        <form class="rentalize-filter-form">
            <label>
                Tanggal Mulai:
                <input type="datetime-local" id="rentalize-start-date" name="rentalize-start-date">
            </label>
            <label>
                Tanggal Selesai:
                <input type="datetime-local" id="rentalize-end-date" name="rentalize-end-date">
            </label>
            <button type="submit" class="rentalize-button" id="rentalize-apply-filters">Cari</button>
        </form>
    `;
        return filterContainer;
    };

    blocks.forEach((block) => {
        const cabangId = block.dataset.cabangId;
        const perPage = parseInt(block.dataset.perPage, 10) || 6;
        const primaryColor = block.dataset.primaryColor || '#2271b1';
        
        // Hitung warna turunan
        const basePrimary = normalizeHex(primaryColor);
        const primaryHover = darkenHex(basePrimary, 0.12);
        const shadowColor = hexToRgba(basePrimary, 0.2);

        // Set CSS variables pada block
        block.style.setProperty('--rentalize-primary', basePrimary);
        block.style.setProperty('--rentalize-primary-hover', primaryHover);
        block.style.setProperty('--rentalize-primary-20', shadowColor);

        let currentPage = 0;
        let hasMore = true;

        // State filter per block
        let currentStartDate = '';
        let currentEndDate = '';

        // State untuk menyimpan aset yang dipilih
        let selectedAssets = new Map();


        const grid = block.querySelector('.rentalize-asset-grid');
        const loadMoreBtn = block.querySelector('.rentalize-load-more');
        const loadMoreBtnWrapper = loadMoreBtn ? loadMoreBtn.parentElement : null;



        if (!cabangId || !grid || !loadMoreBtn) {
            if (grid) {
                grid.innerHTML = '<p class="rentalize-error">ID cabang tidak dikonfigurasi.</p>';
            }
            return;
        }

        // Create filter controls and append to block
        const filterControls = filterController();
        block.insertBefore(filterControls, grid);

        let titleSection = null;

        const ensureTitleSection = () => {
            if (!titleSection) {
                titleSection = document.createElement('div');
                titleSection.className = 'rentalize-title-section';
                // Sisipkan tepat sebelum grid
                grid.parentNode.insertBefore(titleSection, grid);
            }
        };

        const clearTitleSection = () => {
            if (titleSection) {
                titleSection.remove();
                titleSection = null;
            }
        };

        loadMoreBtn.style.display = 'inline-block';

        // Keep track of modal to avoid duplicate creation
        let modalContainer = null;

        const createModal = () => {
            if (modalContainer) return modalContainer;

            modalContainer = document.createElement('div');
            modalContainer.id = 'rentalize-asset-modal';
            modalContainer.innerHTML = `
            <div class="rentalize-modal-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); display: flex; align-items: center; justify-content: center; z-index: 100000;">
                <div class="rentalize-modal-content" style="background: white; max-width: 600px; width: 90%; max-height: 90vh; overflow-y: auto; border-radius: 8px; padding: 20px; position: relative;">
                    <button class="rentalize-modal-close" style="position: absolute; top: 10px; right: 15px; background: none; border: none; font-size: 1.5rem; cursor: pointer;">&times;</button>
                    <div class="rentalize-modal-body"></div>
                </div>
            </div>
        `;

            modalContainer.addEventListener('click', (e) => {
                if (e.target.classList.contains('rentalize-modal-overlay') || e.target.classList.contains('rentalize-modal-close')) {
                    modalContainer.style.display = 'none';
                }
            });

            document.body.appendChild(modalContainer);
            return modalContainer;
        };

        // title
        const updateTitle = (start, end) => {
            ensureTitleSection();
            titleSection.innerHTML = '';

            // Pilih ikon dan teks
            let iconHtml = '<span class="rentalize-title-icon">📋</span>'; // fallback emoji
            let message = '';

            if (!start && !end) {
                message = 'Menampilkan semua aset yang tersedia.';
            } else {
                const formatDateTime = (isoStr) => {
                    const dt = new Date(isoStr);
                    const dayName = dt.toLocaleDateString('id-ID', { weekday: 'long' });
                    const datePart = dt.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
                    const timePart = dt.toLocaleTimeString('id-ID', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    }).replace('.', ':');
                    return `<span class="rentalize-highlighted-text">${dayName}, ${datePart} pukul ${timePart}</span>`;
                };

                if (start && end) {
                    message = `Menampilkan aset tersedia untuk ${formatDateTime(start)} sampai ${formatDateTime(end)}.`;
                } else if (start) {
                    message = `Menampilkan aset tersedia mulai ${formatDateTime(start)}.`;
                } else if (end) {
                    message = `Menampilkan aset tersedia hingga ${formatDateTime(end)}.`;
                }
            }

            // Buat card info
            const card = document.createElement('div');
            card.className = 'rentalize-info-card';
            card.innerHTML = `${iconHtml} <span class="rentalize-info-text">${message}</span>`;
            titleSection.appendChild(card);
        };

        const renderAsset = (asset) => {
            const imageUrl = asset.images?.[0]
                ? `https://api.rentalize.id/assets/${asset.images[0]}`
                : null;
            const price = asset.price_tiers?.[0]?.price || 0;
            const formattedPrice = price.toLocaleString('id-ID');
            const cycleName = asset.price_tiers?.[0]?.cycle_name || '';

            const card = document.createElement('div');
            card.className = 'rentalize-asset-card';

            const imageContainer = document.createElement('div');
            imageContainer.className = 'rentalize-asset-image-container';

            if (imageUrl) {
                const img = document.createElement('img');
                img.src = imageUrl;
                img.alt = asset.name || 'Asset';
                img.className = 'rentalize-asset-image';
                imageContainer.appendChild(img);
            } else {
                const placeholder = document.createElement('div');
                placeholder.className = 'rentalize-asset-placeholder';
                placeholder.textContent = 'Gambar tidak tersedia';
                imageContainer.appendChild(placeholder);
            }

            const title = document.createElement('h4');
            title.className = 'rentalize-asset-title';
            title.textContent = asset.name || 'Tanpa nama';

            const description = document.createElement('p');
            description.className = 'rentalize-asset-description';
            description.textContent = asset.description || 'Tidak ada deskripsi';

            card.appendChild(imageContainer);
            card.appendChild(title);
            card.appendChild(description);

            if (price > 0) {
                const priceDiv = document.createElement('div');
                priceDiv.className = 'rentalize-asset-price';
                priceDiv.textContent = `Rp ${formattedPrice} / ${cycleName}`;
                card.appendChild(priceDiv);
            }

            // Tombol container
            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'rentalize-asset-buttons';

            // 🔘 Tombol Detail (selalu muncul)
            const detailButton = document.createElement('button');
            detailButton.className = 'rentalize-asset-detail-btn';
            detailButton.textContent = 'Detail';
            detailButton.type = 'button';

            detailButton.addEventListener('click', () => {
                const modal = createModal();
                const body = modal.querySelector('.rentalize-modal-body');

                let modalHTML = `<h3>${asset.name || 'Tanpa nama'}</h3>`;
                if (imageUrl) {
                    modalHTML += `<img src="${imageUrl}" alt="${asset.name || 'Asset'}" style="max-width:100%; height:auto; margin: 10px 0;">`;
                }
                modalHTML += `<p><strong>Deskripsi:</strong> ${asset.description || 'Tidak ada deskripsi'}</p>`;
                if (price > 0) {
                    modalHTML += `<p><strong>Harga:</strong> Rp ${formattedPrice} / ${cycleName}</p>`;
                }
                modalHTML += `<p><strong>Status:</strong> ${asset.status || '–'}</p>`;
                modalHTML += `<p><strong>Kode Aset:</strong> ${asset.asset_code || '–'}</p>`;

                body.innerHTML = modalHTML;
                modal.style.display = 'flex';
            });

            buttonContainer.appendChild(detailButton);

            // 🔘 Tombol "Pilih" — hanya muncul jika start_date & end_date diisi
            if (currentStartDate && currentEndDate) {
                const selectButton = document.createElement('button');
                selectButton.className = 'rentalize-asset-select-btn';
                selectButton.textContent = 'Sewa';
                selectButton.type = 'button';

                selectButton.addEventListener('click', () => {
                    const key = getAssetKey(asset);
                    if (!key) return;

                    // Toggle state
                    if (selectedAssets.has(key)) {
                        selectedAssets.delete(key);
                    } else {
                        selectedAssets.set(key, asset);
                    }

                    // ✅ Update visual langsung pada card ini
                    card.classList.toggle('rentalize-asset-selected', selectedAssets.has(key));

                    // Update panel bawah
                    updateBottomPanel();
                });

                buttonContainer.appendChild(selectButton);
            }

            card.appendChild(buttonContainer);
            return card;
        };

        // ✨ Fungsi loadMore yang diperbarui dengan dukungan filter
        const loadMore = async () => {
            if (!hasMore || loadMoreBtn.disabled) return;

            loadMoreBtn.disabled = true;
            loadMoreBtn.textContent = 'Memuat...';

            // Bangun query params
            const params = new URLSearchParams({
                cabang_id: cabangId,
                per_page: perPage,
                page: currentPage + 1
            });

            if (currentStartDate) params.append('start_date', currentStartDate);
            if (currentEndDate) params.append('end_date', currentEndDate);

            try {
                const result = await apiFetch({
                    path: `/rentalize-api/v1/rentalize-assets?${params.toString()}`,
                    method: 'GET'
                });
                const data = result.data || [];
                const pagination = result.pagination || {};

                if (data.length > 0) {
                    data.forEach((asset) => {
                        grid.appendChild(renderAsset(asset));
                    });
                    currentPage += 1;
                    hasMore = data.length === perPage && currentPage < pagination.total_pages;
                    // ✅ Ada data → tampilkan judul
                    //updateTitle(currentStartDate, currentEndDate);
                } else {
                    // ❌ Tidak ada data → sembunyikan judul
                    clearTitleSection();
                    hasMore = false;
                }
            } catch (error) {
                console.error('Error memuat aset:', error);
                clearTitleSection();
                hasMore = false;
            } finally {
                loadMoreBtn.disabled = false;
                loadMoreBtn.textContent = 'Muat Lebih Banyak';
                loadMoreBtn.addEventListener('click', loadMore);
                if (!hasMore && loadMoreBtnWrapper) {
                    loadMoreBtnWrapper.style.display = 'none';
                }
            }
        };

        // ✨ Event listener untuk tombol "Terapkan Filter"
        const applyFilterBtn = block.querySelector('#rentalize-apply-filters');
        const startDateInput = block.querySelector('#rentalize-start-date');
        const endDateInput = block.querySelector('#rentalize-end-date');

        if (applyFilterBtn) {
            applyFilterBtn.addEventListener('click', (e) => {
                e.preventDefault(); // karena tombol di dalam form

                clearTitleSection();
                clearAllSelectedAssets();

                // Ambil nilai input
                const newStart = startDateInput?.value || '';
                const newEnd = endDateInput?.value || '';

                // Simpan ke state
                currentStartDate = newStart;
                currentEndDate = newEnd;

                // Reset pagination & grid
                currentPage = 0;
                hasMore = true;
                grid.innerHTML = ''; // kosongkan hasil sebelumnya

                // Tampilkan tombol "Load More"
                if (loadMoreBtnWrapper) {
                    //loadMoreBtnWrapper.style.display = 'block';
                }

                // Muat data pertama dengan filter baru
                loadMore();

                // ✅ Update judul berdasarkan filter                
                updateTitle(newStart, newEnd);
            });
        }

        const getAssetKey = (asset) => {
            // Gunakan _id (MongoDB ObjectId) sebagai key utama
            const key = asset._id || asset.id || asset.asset_code;
            return key ? String(key).trim() : null;
        };

        let bottomPanel = null;
        const updateBottomPanel = () => {
            if (selectedAssets.size === 0) {
                if (bottomPanel) {
                    bottomPanel.remove();
                    bottomPanel = null;
                }
                return;
            }

            if (!bottomPanel) {
                bottomPanel = document.createElement('div');
                bottomPanel.className = 'rentalize-bottom-panel';
                // Terapkan CSS variables untuk warna brand
                bottomPanel.style.setProperty('--rentalize-primary', basePrimary);
                bottomPanel.style.setProperty('--rentalize-primary-hover', primaryHover);
                document.body.appendChild(bottomPanel);

                bottomPanel.addEventListener('click', (e) => {
                    if (e.target.classList.contains('rentalize-rent-now-btn')) {
                        const modal = createOrderModal();
                        modal.style.display = 'flex';
                    } else if (e.target.classList.contains('rentalize-clear-all-btn')) {
                        clearAllSelectedAssets();
                    }
                });
            }

            bottomPanel.innerHTML = `
        <div class="rentalize-bottom-panel-content">            
            <span>${selectedAssets.size} Barang dipilih</span>
            <div>
            <button class="rentalize-clear-all-btn">Hapus Semua</button>
            <button class="rentalize-rent-now-btn">Sewa Sekarang</button>
            </div>
        </div>
    `;
        };

        const clearAllSelectedAssets = () => {
            // Kosongkan Map seleksi
            selectedAssets.clear();

            // Hapus class 'selected' dari semua card yang sedang ditampilkan
            const selectedCards = grid.querySelectorAll('.rentalize-asset-card.rentalize-asset-selected');
            selectedCards.forEach(card => {
                card.classList.remove('rentalize-asset-selected');
            });

            // Perbarui panel bawah (akan otomatis disembunyikan karena size = 0)
            updateBottomPanel();
        };

        let orderModal = null;

        const createOrderModal = () => {
            if (orderModal) return orderModal;

            orderModal = document.createElement('div');
            orderModal.id = 'rentalize-order-modal';
            // Terapkan CSS variables untuk warna brand
            orderModal.style.setProperty('--rentalize-primary', basePrimary);
            orderModal.style.setProperty('--rentalize-primary-hover', primaryHover);
            orderModal.style.setProperty('--rentalize-primary-20', shadowColor);
            orderModal.innerHTML = `       
            <div class="rentalize-modal-card">
                <div class="rentalize-modal-header">
                    <h3>Buat Pesanan</h3>
                    <button class="rentalize-modal-close">&times;</button>
                </div>
                <div class="rentalize-order-content">
                    <!-- Form Customer -->
                    <form class="rentalize-order-form">
                        <div class="form-group">
                            <label>Nama Penyewa *</label>
                            <input type="text" name="customer_name" placeholder="Tulis nama penyewa" required>
                        </div>
                        <div class="form-group">
                            <label>NIK *</label>
                            <input type="text" name="customer_national_id" placeholder="NIK" required>
                        </div>
                        <div class="form-group">
                            <label>Nomor HP *</label>
                            <div class="phone-input-wrapper">
                                <span class="phone-prefix">+62</span>
                                <input type="tel" name="customer_phone" placeholder="8567253xxxx" required>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" name="customer_email" placeholder="Email">
                        </div>
                        <div class="form-group">
                            <label>Jenis Sosial Media</label>
                            <select name="customer_social_media_type">
                                <option value="">Pilih sosial media</option>
                                <option value="whatsapp">WhatsApp</option>
                                <option value="instagram">Instagram</option>
                                <option value="facebook">Facebook</option>
                                <option value="twitter">Twitter/X</option>
                                <option value="tiktok">TikTok</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Username Sosial Media</label>
                            <input type="text" name="customer_social_media_username" placeholder="@username atau nomor">
                        </div>
                        <div class="form-group">
                            <label>Alamat Penyewa *</label>
                            <textarea name="customer_address" rows="2" placeholder="Tulis alamat penyewa disini" required></textarea>
                        </div>
                        <div class="form-group">
                            <label>Lokasi Pengambilan *</label>
                            <input type="text" name="pickup_location" placeholder="Masukkan lokasi pengambilan" required>
                        </div>
                        <div class="form-group">
                            <label>Lokasi Pengembalian *</label>
                            <input type="text" name="return_location" placeholder="Masukkan lokasi pengembalian" required>
                        </div>
                        <div class="form-group">
                            <label>Keterangan</label>
                            <textarea name="notes" rows="2" placeholder="Tulis keterangan tambahan disini"></textarea>
                        </div>
                    </form>

                    <!-- Daftar Aset -->
                    <div class="rentalize-order-assets-section">
                        <h4>Aset yang Dipesan (${selectedAssets.size})</h4>
                        <div class="rentalize-order-assets-list" id="rentalize-order-assets-list">
                            <!-- Diisi oleh renderOrderAssetsList() -->
                        </div>
                    </div>

                    
                </div>
                <!-- Aksi -->
                    <div class="form-actions">
                        <button type="button" class="rentalize-modal-cancel">Batal</button>
                        <button type="button" class="rentalize-button" id="rentalize-submit-order">Kirim Pesanan</button>
                    </div>
            </div>      
    `;
            document.body.appendChild(orderModal);

            // Render daftar aset
            const renderOrderAssetsList = () => {
                const listEl = orderModal.querySelector('#rentalize-order-assets-list');
                if (!listEl) return;

                if (selectedAssets.size === 0) {
                    listEl.innerHTML = '<p class="rentalize-no-assets">Tidak ada aset yang dipilih.</p>';
                    return;
                }

                const fragment = document.createDocumentFragment();
                selectedAssets.forEach((asset) => {
                    const item = document.createElement('div');
                    item.className = 'rentalize-order-asset-item';
                    const key = getAssetKey(asset);
                    item.dataset.assetKey = key;

                    const name = asset.name || 'Tanpa nama';
                    const price = asset.price_tiers?.[0]?.price
                        ? `Rp ${(asset.price_tiers[0].price).toLocaleString('id-ID')} / ${asset.price_tiers[0].cycle_name}`
                        : 'Harga tidak tersedia';

                    item.innerHTML = `
                <div class="rentalize-asset-info">
                    <strong>${name}</strong><br>
                    <small>${price}</small>
                </div>
                <button type="button" class="rentalize-remove-from-order" title="Hapus dari pesanan">&times;</button>
            `;
                    fragment.appendChild(item);
                });

                listEl.innerHTML = '';
                listEl.appendChild(fragment);
            };

            // Event: hapus aset dari pesanan
            orderModal.addEventListener('click', (e) => {
                if (e.target.classList.contains('rentalize-remove-from-order')) {
                    const item = e.target.closest('.rentalize-order-asset-item');
                    const key = item?.dataset.assetKey;
                    if (key && selectedAssets.has(key)) {
                        // Hapus dari state
                        selectedAssets.delete(key);

                        // Hapus highlight dari card di grid
                        const card = grid.querySelector(`.rentalize-asset-card[data-asset-key="${key}"]`);
                        if (card) {
                            card.classList.remove('rentalize-asset-selected');
                        }

                        // Update panel & daftar
                        updateBottomPanel();
                        renderOrderAssetsList();

                        // Jika tidak ada aset, tutup modal
                        if (selectedAssets.size === 0) {
                            orderModal.style.display = 'none';
                        }
                    }
                }
            });

            // Event: tutup modal
            const closeBtns = orderModal.querySelectorAll('.rentalize-modal-close, .rentalize-modal-cancel');
            closeBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    orderModal.style.display = 'none';
                });
            });

            orderModal.addEventListener('click', (e) => {
                if (e.target === orderModal) orderModal.style.display = 'none';
            });

            // Event: kirim pesanan
            orderModal.querySelector('#rentalize-submit-order')?.addEventListener('click', () => {
                const form = orderModal.querySelector('.rentalize-order-form');
                if (!form.checkValidity()) {
                    form.reportValidity();
                    return;
                }

                const formData = new FormData(form);
                const assetsArray = Array.from(selectedAssets.values());

                // Helper: konversi datetime-local (YYYY-MM-DDTHH:MM) ke ISO 8601 (YYYY-MM-DDTHH:MM:SS)
                const toISO8601 = (datetimeLocal) => {
                    if (!datetimeLocal) return null;
                    // Jika sudah ada detik, kembalikan langsung
                    if (/T\d{2}:\d{2}:\d{2}/.test(datetimeLocal)) return datetimeLocal;
                    // Tambahkan :00 untuk detik
                    return datetimeLocal + ':00';
                };

                // Hitung total harga dari semua aset yang dipilih
                const totalPrice = assetsArray.reduce((sum, asset) => {
                    const price = asset.price_tiers?.[0]?.price || 0;
                    return sum + price;
                }, 0);

                // Hitung tax 11%
                const taxPercent = 11;
                const totalTax = Math.round(totalPrice * taxPercent / 100);

                // Format nomor telepon dengan prefix 62
                const rawPhone = formData.get('customer_phone') || '';
                const formattedPhone = '62' + rawPhone.replace(/^0+/, '');

                const payload = {
                    branch_id: cabangId,
                    customer_national_id: formData.get('customer_national_id'),
                    customer_name: formData.get('customer_name'),
                    customer_email: formData.get('customer_email') || null,
                    customer_phone: formattedPhone,
                    customer_address: formData.get('customer_address'),
                    customer_social_media_type: formData.get('customer_social_media_type') || null,
                    customer_social_media_username: formData.get('customer_social_media_username') || null,
                    date_order: new Date().toISOString(),
                    date_start: toISO8601(currentStartDate),
                    date_end: toISO8601(currentEndDate),
                    pickup_location: formData.get('pickup_location') || null,
                    return_location: formData.get('return_location') || null,
                    total_price: totalPrice,
                    tax: taxPercent,
                    total_tax: totalTax,
                    notes: formData.get('notes') || null,
                    assets_json: JSON.stringify(assetsArray.map(a => ({
                        asset_id: a._id || a.id,
                        price_at_order_creation: a.price_tiers?.[0]?.price || 0
                    })))
                };

                submitOrder(payload);
            });

            // Render awal
            renderOrderAssetsList();

            return orderModal;
        };

        const submitOrder = async (payload) => {
            const submitBtn = orderModal.querySelector('#rentalize-submit-order');
            const originalText = submitBtn.textContent;

            // Tampilkan loading
            submitBtn.disabled = true;
            submitBtn.textContent = 'Mengirim...';

            // Gunakan WordPress REST API sebagai proxy
            const apiRoot = window.wpApiSettings?.root || '/wp-json/';
            const apiUrl = apiRoot + 'rentalize-api/v1/orders/public';

            // Buat FormData dari payload
            const formData = new FormData();
            formData.append('date_order', payload.date_order);
            formData.append('date_start', payload.date_start);
            formData.append('date_end', payload.date_end);
            formData.append('pickup_location', payload.pickup_location || '');
            formData.append('return_location', payload.return_location || '');
            formData.append('notes', payload.notes || '');
            formData.append('branch_id', payload.branch_id);
            formData.append('customer_name', payload.customer_name);
            formData.append('customer_email', payload.customer_email || '');
            formData.append('customer_phone', payload.customer_phone);
            formData.append('customer_address', payload.customer_address);
            formData.append('customer_national_id', payload.customer_national_id);
            formData.append('customer_social_media_type', payload.customer_social_media_type || '');
            formData.append('customer_social_media_username', payload.customer_social_media_username || '');
            formData.append('assets_json', payload.assets_json);
            formData.append('tax', payload.tax.toString());
            formData.append('total_tax', payload.total_tax.toString());
            formData.append('total_price', payload.total_price.toString());

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    body: formData
                });

                const result = await response.json();

                if (result.meta?.success) {
                    alert('Pesanan berhasil dibuat!');
                    clearAllSelectedAssets();
                    orderModal.style.display = 'none';
                } else {
                    const errorMsg = result.meta?.message || 'Gagal membuat pesanan.';
                    alert('Error: ' + errorMsg);
                }
            } catch (err) {
                console.error('Error saat mengirim pesanan:', err);
                alert('Error: Terjadi kesalahan. Silakan coba lagi.');
            } finally {
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            }
        };

        // Inisialisasi judul
        updateTitle('', '');

        // Muat halaman pertama saat halaman dimuat
        loadMore();
    });
});